module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/220-vietnam-4f2b141f9c13a1fb07e23713236535e4.svg";